// src/hooks/useA4Print.js
import * as React from "react";
import { useReactToPrint } from "react-to-print";
import { makeStyles } from "@material-ui/core/styles";

// const a4Styles = makeStyles({
//   centreItems: { display: "flex", justifyContent: "center" },
//   emergencyListView: { display: "flex", justifyContent: "center" },
// });


// const getA4PageStyle = () => `
//   @page {
//     size: A4 portrait;
//     margin: 5mm 5mm 5mm 5mm; /* adjust margins as needed */
//   }

//   #a4Print {
//     width: 100%;
//     min-height: 297mm;
//     padding: 0;
//     box-sizing: border-box;
//   }

//   body {
//     font-family: Arial, sans-serif;
//     font-size: 16pt; /* increased from 14pt */
//     line-height: 1.6;
//     color: #000;
//   }

//   table {
//     width: 100%;
//     border-collapse: collapse;
//     font-size: 16pt; /* increase table text */
//   }

//   th, td {
//     padding: 8px 10px; /* slightly larger padding */
//     border: 1px solid #ccc;
//   }

//   th {
//     background-color: #f2f2f2;
//     text-align: left;
//   }

//   td.amount, td.unitPrice {
//     text-align: right;
//     font-size: 16pt; /* increase table text */

//   }

//   @media print {
//     button, .no-print {
//       display: none;
//     }
//   }
// `;
const getA4PageStyle = () => {
  return `
  @media print {
    width : 205mm;
    margin-left: 100px;
  }
  `;
};

function useA4Print(title, onAfterPrint) {
  const componentRef = React.useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: title,
    pageStyle: getA4PageStyle, // inject styles directly
    onAfterPrint,
  });

  return {
    componentRef,
    handlePrint,
    
  };
}

export { useA4Print };
